import React from "react";
import BenifitApp from "../components/BenifitApp";
import rest1 from "../assets/images/rest1.png";
import rest2 from "../assets/images/rest2.png";
import rest3 from "../assets/images/rest3.png";
import ClientTestimonial from "../components/ClientTestimonial";
import faqImage from "../assets/images/faq_img.webp";
import sec from "../assets/images/sec1.webp";
import Faq from "../components/Faq";
import MailBox from "../assets/icons/MailBox";
import Call from "../assets/icons/Call";
import Rightarrow from "../assets/icons/Rightarrow";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";













const AddRestaurant = () => {
const { t } = useTranslation();
  const benefits = [
    {
      title: t("sign_up"),
      description: t("sign_up_description"),
      image: rest1,
    },
    {
      title: t("list_your_restaurant"),
      description: t("list_your_restaurant_description"),
      image: rest2,
    },
    {
      title: t("start_receiving_orders"),
      description: t("start_receiving_orders_description"),
      image: rest3,
    },
    {
      title: t("grow_with_loadinn"),
      description: t("grow_with_loadinn_description"),
      image: rest1,
    },
  ];
  let faqs = [

  {
    question: t("how_can_restaurants_sign_up_on_loadinn"),
    answer: t("restaurants_can_sign_up_by_visiting_website_clicking_become_restaurant_partner_filling_form_purchasing_subscription_and_waiting_for_approval"),
  },

  {
    question: t("is_there_an_approval_process_before_restaurants_can_start_receiving_orders"),
    answer: t("yes_loadinn_verifies_all_restaurant_profiles_before_making_them_live"),
  },

  {
    question: t("what_subscription_plans_do_you_offer_for_restaurants"),
    answer: t("we_offer_five_different_subscription_plans_visit_our_website_for_details"),
  },

  {
    question: t("are_there_any_additional_charges_beyond_the_subscription_fee"),
    answer: t("each_subscription_plan_includes_a_set_number_of_orders_beyond_that_limit_a_platform_fee_is_applied_additionally_a_transaction_fee_is_applied_to_each_order_via_payment_gateway"),
  },

  {
    question: t("is_there_a_fee_for_each_order_placed_through_the_platform"),
    answer: t("yes_beyond_the_included_orders_in_your_subscription_a_platform_fee_and_payment_gateway_transaction_fee_apply"),
  },

  {
    question: t("how_can_restaurants_update_their_menu_on_loadinn"),
    answer: t("restaurants_can_update_their_menu_themselves_or_contact_us_via_chat_or_email_for_assistance"),
  },

  {
    question: t("can_restaurants_set_different_prices_or_special_offers_for_online_orders"),
    answer: t("yes_restaurants_have_full_control_over_pricing_and_promotions"),
  },

  {
    question: t("what_happens_if_a_restaurant_wants_to_temporarily_pause_orders"),
    answer: t("restaurants_can_stop_taking_orders_by_switching_to_offline_mode_on_the_platform"),
  },

  {
    question: t("do_restaurants_need_their_own_delivery_staff_or_does_loadinn_provide_couriers"),
    answer: t("restaurants_do_not_need_their_own_delivery_staff_loadinn_provides_all_delivery_services"),
  },

  {
    question: t("how_do_restaurants_track_deliveries"),
    answer: t("restaurants_do_not_have_a_direct_delivery_tracking_system"),
  },

  {
    question: t("what_happens_if_a_courier_is_delayed"),
    answer: t("restaurants_can_report_delivery_issues_to_loadinn_via_chat_support"),
  },

  {
    question: t("how_do_restaurants_receive_payments_for_orders"),
    answer: t("payments_are_transferred_directly_to_the_restaurants_bank_account"),
  },

  {
    question: t("how_often_are_payouts_made"),
    answer: t("payouts_are_processed_daily"),
  },

  {
    question: t("are_there_any_transaction_fees_deducted_from_the_payouts"),
    answer: t("yes_a_transaction_fee_is_applied_via_our_payment_gateway_stripe"),
  },

  {
    question: t("what_should_restaurants_do_if_they_receive_a_fraudulent_order_or_incorrect_payment"),
    answer: t("restaurants_should_contact_loadinn_support_and_report_the_issue_immediately"),
  },

  {
    question: t("how_can_restaurants_contact_loadinn_support"),
    answer: t("restaurants_can_reach_our_support_team_via_chat"),
  },

];

  return (
    <React.Fragment>
      <section className="rest_banner">
        <div className="wrapper">
          <div className="rest_bntext">
            <h1 className="usable_title">{t("add_your_restaurant_to_loadInn")}</h1>
            <p className="para_common">
              {t("join_our_network_and_reach_more_customers_today")}
            </p>
            <Link to="/add-restaurant/form" className="btn btn-secondary">{t("get_started")}</Link>
          </div>
        </div>
      </section>
      <section className="benifit_card_section">
        <div className="wrapper">
          <div className="benifit_grid">
            {benefits.map((benefit, index) => (
              <BenifitApp
                key={index}
                title={benefit.title}
                description={benefit.description}
                image={benefit.image}
              />
            ))}
          </div>
        </div>
      </section>
      <div className="launch_section_grid">
        <div className="launch_img">
                <img src={sec} alt="Launch Your Internet Ordering Business" />
        </div>
        <div className="bg_image_yellow launch_content">
            <h2 className="subtitle_common">
            {t("launch_your")} <span className="text-primary">{t("internet_ordering_business")}</span>
            </h2>
            <p className="para_common">
            {t("please_make_sure_the_paperwork_is_ready_for_a_seamless_signup")}
            </p>
            <ul className="launch_list">
                <li>{t("pvd_number")}</li>
                <li>{t("company_details")}</li>
                <li>{t("your_restaurant_menu")}</li>
                <li>{t("bank_account_details")}</li>
                <li>{t("representative_details")}</li>
            </ul>
        </div>
      </div>
      <ClientTestimonial />
      <section className="bg_image_yellow bg_cta_scs">
        <div className="wrapper">
          <div className="bg_cta_scs_cont">
            <h2 className="subtitle_common">
                {t("get")} <span className="text-secondary">{t("started")}</span>
            </h2>
            <p className="para_common">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            
            <Link href="/add-restaurant/form" className="btn btn-secondary">{t("register_your_restaurant_now")}<Rightarrow /></Link>
          </div>
        </div>
      </section>
      <Faq faqs={faqs} faqimg={faqImage} />
      <section className="bg_image_yellow">
        <div className="wrapper">
          <div className="cta_grid">
            <div className="cta_title">
              <h2 className="subtitle_common">
                {/* Need{" "}
                <span className="text-primary">help?</span> */}
                      {t("need")} <span className="text-primary">{t("help")}</span>?

              </h2>
              <p className="para_common">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
              </p>
            </div>
            <div className="cta_buttons">
                <Link href="mailto:example@gmail.com" className="btn btn-primary"><MailBox /> {t("email_ud")}</Link>
                <Link href="tel:9191919191" className="btn btn-primary"><Call /> {t("call_us")}</Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AddRestaurant;
